
import PropTypes from "prop-types";
import { TextField as MaterialTextField } from "@mui/material";
import isEmpty from "lodash/isEmpty";
import { IconButton } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import React from "react";


const TextFieldSimple = React.forwardRef((props, ref) => {
    const { id, field, errors, moreInfo, clearable = false, ...others } = props;
    const clearableStyles = clearable ? { "& .MuiSelect-iconOutlined ": { display: others.value ? "none" : "" } } : {};
    const clearableInputProps = clearable ? {
        endAdornment: (<IconButton onClick={() => {
            others.onChange({
                target: {
                    value: ''
                }
            });
        }} sx={{ display: others.value ? "" : "none" }}><ClearIcon /></IconButton>)
    } : {};
    const helperText = (!isEmpty(errors) && errors[field || id]) || props.helperText;

    return (
        <MaterialTextField
            {...others}
            ref={ref}
            sx={{ ...clearableStyles, ...others.sx }}
            InputProps={{
                ...clearableInputProps,
                ...others.InputProps,
            }}
            id={id}
            error={props.error || (!isEmpty(errors) && !isEmpty(errors[field || id]))}
            helperText={helperText}
        />
    )
});

TextFieldSimple.displayName = "TextFieldSimple";

const TextFieldWithMoreInfo = React.forwardRef((props, ref) => {
    const { moreInfo, key, ...others } = props;
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }} key={key}>
            <TextFieldSimple {...others} ref={ref} />
            {moreInfo}
        </div>
    )
})

TextFieldWithMoreInfo.displayName = "TextFieldWithMoreInfo";

const TextField = React.forwardRef((props, ref) => {
    if (props.moreInfo)
        return <TextFieldWithMoreInfo {...props} ref={ref} />
    else
        return <TextFieldSimple {...props} ref={ref} />
});

TextField.defaultProps = {
    margin: "normal",
    variant: "outlined"
};

TextField.propTypes = {
    moreInfo: PropTypes.node,
};

TextField.displayName = "TextField";

export default TextField;